export default "__VITE_ASSET__4RVyT3g$__"